import {QueueItemType} from "../../types";
import MediaCenterBox from "../../components/ImageCenter/MediaCenterBox";

export interface QueueItemGiphyProps {
    data: QueueItemType;
}

export default function QueueItemGiphy({data}: QueueItemGiphyProps) {
    return (
        <MediaCenterBox className="!bg-dark-black rounded-none max-h-[600px]">
            <iframe sandbox="allow-scripts allow-same-origin" className="border-none h-200px sm:h-[300px] md:h-[400px] lg:h-[600px] w-full" width="100%" height="auto" src={data.metadata.src}
                    title={data?.metadata?.title || 'youtube video'} frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen></iframe>
        </MediaCenterBox>
    );
}
